import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AWS_ATHENA } from "../../Constants"

function ZdqAwsAthenaConnector() {
    return <ZdqConnectorSetup vendor={AWS_ATHENA}></ZdqConnectorSetup>
}

export default ZdqAwsAthenaConnector 